<div class="container">
    <h2 mat-dialog-title>Suspend Beyond Supplier</h2>

    <mat-dialog-content class="dialog-body">
        <p>Are you sure you want to suspend this beyond supplier?</p>

        <div class="item" *ngFor="let item of items">
            <span class="label">{{ item.title }}: </span>
            <span class="value" *ngIf="item.format == undefined">{{ this.beyondSupplier[item.name] }}</span>
            <span class="value" *ngIf="item.format === 'titlecase'">{{ this.beyondSupplier[item.name] | titlecase }}</span>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="form-actions">
        <button mat-flat-button color="warn" (click)="suspend()">Suspend</button>
        <button mat-flat-button class="cancel" (click)="cancel()">Cancel</button>
    </mat-dialog-actions>
</div>
